module.exports = __webpack_public_path__ + "img/cover-opet.b5d623c3.png";